import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useUserByLicensedProductsQuery, {
	type useUserByLicensedProductsQuery$data,
	type useUserByLicensedProductsQuery$variables,
} from './__generated__/useUserByLicensedProductsQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadGetLicensedProductsQuery = (): Promise<{
	data: useUserByLicensedProductsQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query<useUserByLicensedProductsQuery$data, useUserByLicensedProductsQuery$variables>({
		query: useUserByLicensedProductsQuery,
	});
};
